import enums from "./../enums";

const tournament = (
	state = {
		tournaments: {},
		tournamentLoading: false,
		matches: [],
		matchLoading: false,
		scoreboard: {},
	},
	action
) => {
	switch (action.type) {
		case enums.LOADING_TOURNAMENT: {
			return { ...state, tournamentLoading: action.payload };
		}
		case enums.LOADING_MATCH_LIST: {
			return { ...state, matchLoading: action.payload };
		}
		case enums.MATCH_LIST: {
			return { ...state, matches: action.payload };
		}
		case enums.TOURNAMENT_LIST: {
			return { ...state, tournaments: action.payload };
		}
		case enums.CUSTOM_MARKET_LIST: {
			const marketItem = action.payload.marketItem,
				activeTournament = action.payload.activeTournament,
				activeSport = action.payload.activeSport;

			return {
				...state,
				tournaments: {
					...state["tournaments"],
					sports: state.tournaments.sports.map((sport, index) => {
						if (sport.id !== activeSport.id) {
							return sport;
						}

						return {
							...sport,
							categories: sport.categories.map((category) => {
								if (category.id != activeTournament.category.id) {
									return category;
								}

								return {
									...category,
									tournaments: category.tournaments.map((t) => {
										if (t.id != activeTournament.id) {
											return t;
										}

										return {
											...t,
											matches: t.matches.map((m) => {
												return {
													...m,
													markets: [
														...m.markets,
														{
															id: marketItem.value,
															name: marketItem.text,
															outcomes: [
																{
																	name: "test-odd-1",
																	id: "1",
																	odds: (
																		Math.random() * 10
																	).toFixed(2),
																},
																{
																	name: "test-odd-2",
																	id: "2",
																	odds: (
																		Math.random() * 10
																	).toFixed(2),
																},
															],
														},
													],
												};
											}),
										};
									}),
								};
							}),
						};
					}),
				},
			};
		}
		case enums.SCOREBOARD: {
			return { ...state, scoreboard: action.payload };
		}
		default:
			return { ...state };
	}
};

export default tournament;
